module.exports = __webpack_public_path__ + "img/payment-methods.4d81426b.jpg";